/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_Hard_RepsInputs */

const en_us2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 left`)
};

const pt_br2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava +1–2`)
};

const es_419_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quedaban 1–2`)
};

const pt_pt2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava +1–2`)
};

const fr_fr2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 en réserve`)
};

const de_de2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 übrig`)
};

const it_it2_workout_quick_effort_hard_reps = /** @type {(inputs: Workout_Quick_Effort_Hard_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 in riserva`)
};

/**
* | output |
* | --- |
* | "1–2 left" |
*
* @param {Workout_Quick_Effort_Hard_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_hard_reps = /** @type {((inputs?: Workout_Quick_Effort_Hard_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_Hard_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_hard_reps(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_hard_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_hard_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_hard_reps(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_hard_reps(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_hard_reps(inputs)
	return en_us2_workout_quick_effort_hard_reps(inputs)
});
export { workout_quick_effort_hard_reps as "workout-quick.effort_hard_reps" }